import { FC } from 'react';
import { MuiModal } from 'src/components/material/MuiModal';
import styles from './UnsubscribeFromCircle.module.scss';

interface UnsubscribeModalProps {
  isOpenModal: boolean;
  setIsOpenModal: (open: boolean) => void;
  handleUnsubscribe: () => void;
}

export const UnsubscribeModal: FC<UnsubscribeModalProps> = ({
  isOpenModal,
  setIsOpenModal,
  handleUnsubscribe,
}) => {
  return (
    <MuiModal open={isOpenModal} setOpen={setIsOpenModal} width={400}>
      <div className={styles.unsubscribeModal}>
        <p className={styles.confirmText}>
          Are you sure you want to leave this Circle? You will lose access to
          all information and documents from this group.
        </p>
        <div className={styles.btns}>
          <button
            className={styles.btnCancel}
            onClick={() => setIsOpenModal(false)}
          >
            Cancel
          </button>
          <button
            className={styles.btn}
            onClick={() => {
              handleUnsubscribe();
              setIsOpenModal(false);
            }}
          >
            Yes
          </button>
        </div>
      </div>
    </MuiModal>
  );
};
